export default {"src":"/_next/static/media/logout.820cef9f.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};